import { type RecentColleague } from "@src/appV2/Agents/api/useGetRecentColleagues";

import { type WorkerPublicProfile } from "../hooks/useGetWorkerPublicProfile";
import { WorkTogetherStack } from "./WorkTogetherStack";

interface WorkTogetherStackContainerProps {
  workers: WorkerPublicProfile[];
  friendsMap?: Map<string, WorkerPublicProfile>;
  recentColleaguesMap?: Map<string, RecentColleague>;
}

export function WorkTogetherStackContainer(props: WorkTogetherStackContainerProps) {
  return <WorkTogetherStack {...props} />;
}
